import { CategoryQueryVariables } from '@/__generated__/graphql';
import { CATEGORIES_FRAGMENT } from '@/gql/fragments/categories.gql';
import { CATEGORY_QUERY } from '@/gql/queries/categoryQueries.gql';
import { useQuery } from '@apollo/client';
import { createFragmentArrayParser } from '@liquorice/gql-utils';

export const useCategory = (variables: CategoryQueryVariables) => {
  const { data, loading, error } = useQuery(CATEGORY_QUERY, {
    variables,
  });
  if (error) return null;

  const parseCategories = createFragmentArrayParser(CATEGORIES_FRAGMENT, (data) => data);

  const result = parseCategories(data?.category);

  return {
    result,
    loading,
    error,
  };
};
